
import { Badge } from '@/components/ui/badge';

export const ReferralBadges = () => {
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-gray-700">Badge Levels</h3>
      <div className="flex flex-wrap gap-2">
        <div className="text-xs bg-amber-600 text-white px-2 py-1 rounded-full">Bronze: 1-99</div>
        <div className="text-xs bg-gray-400 text-white px-2 py-1 rounded-full">Silver: 100-499</div>
        <div className="text-xs bg-yellow-500 text-white px-2 py-1 rounded-full">Gold: 500-999</div>
        <div className="text-xs bg-cyan-500 text-white px-2 py-1 rounded-full">Platinum: 1000-4999</div>
        <div className="text-xs bg-purple-600 text-white px-2 py-1 rounded-full">Legend: 5000+</div>
      </div>
    </div>
  );
};
